import { useState } from 'react'
import { Link } from 'react-router-dom'
import { api, qs } from '../../lib/api.js'
import { useHatcheryScope } from '../../lib/scope.js'
import { Card, Empty, ErrorBox, Page, Spinner, StatusBadge, useAsync } from '../../components/Ui.jsx'
import { fmtDate, inr, lakh, statusHint } from '../../lib/format.js'

export default function Orders () {
  const scope = useHatcheryScope()
  const [filter, setFilter] = useState('open')
  const { data, error, loading, reload } = useAsync(
    () => api.get(`/hatchery/orders${qs({ status: filter, hatcheryId: scope.hatcheryId })}`),
    [filter, scope.hatcheryId],
    { live: ['orders'] }
  )

  return (
    <Page
      title="Bookings on my batches"
      subtitle="Every booking the operator desk has placed against your seed. You are paid in full before packing starts."
      crumb={scope.asAdmin ? <Link to={`/hatchery${scope.link}`}>← Portal view</Link> : null}
    >
      <Card padded={false}>
        <div className="filterbar">
          <div className="chips">
            {[['open', 'Open'], ['', 'All'], ['payout_released', 'Cleared to pack'], ['completed', 'Completed']].map(([v, label]) => (
              <button key={label} className={`chip ${filter === v ? 'on' : ''}`} onClick={() => setFilter(v)}>{label}</button>
            ))}
          </div>
        </div>

        {loading
          ? <Spinner />
          : error
            ? <div className="body"><ErrorBox error={error} onRetry={reload} /></div>
            : (
              <div className="scroll-x">
                <table>
                  <thead>
                    <tr>
                      <th>Order</th><th>Farmer</th><th>Delivery to</th><th>Stocking date</th>
                      <th className="num">Qty</th><th className="num">Order value</th><th className="num">Your payout</th><th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.orders.map(o => (
                      <tr key={o._id}>
                        <td className="mono">{o.orderCode}<span className="t-sub">{o.batch?.batchCode}</span></td>
                        <td>{o.farmer?.name}<span className="t-sub">{o.farmer?.phone}</span></td>
                        <td>{[o.farmer?.village, o.farmer?.mandal].filter(Boolean).join(', ')}<span className="t-sub">{o.distanceKm} km haul</span></td>
                        <td className="tight">{fmtDate(o.targetStockingDate)}<span className="t-sub">ready {fmtDate(o.matchedReadyDate)}</span></td>
                        <td className="num">{lakh(o.quantityLakh)}<span className="t-sub">{o.plStage}</span></td>
                        <td className="num">{inr(o.totalAmount)}</td>
                        <td className="num">{o.payoutAmount ? inr(o.payoutAmount) : <span className="muted">pending</span>}</td>
                        <td>
                          <StatusBadge status={o.status} />
                          <span className="t-sub">{statusHint(o.status)}</span>
                        </td>
                      </tr>
                    ))}
                    {!data.orders.length && <tr><td colSpan={8}><Empty>No bookings in this view.</Empty></td></tr>}
                  </tbody>
                </table>
              </div>
              )}
      </Card>
    </Page>
  )
}
